import { Routes } from '@angular/router';
import { authGuard, noAuthGuard, roleGuard } from '@app/core/guards/auth.guard';
import { canDeactivateGuard } from '@app/core/guards/can-deactivate.guard';
import { Constants } from './core/services/constants';

export const routes: Routes = [
  {
    path: '',
    redirectTo: Constants.mainLandingPage,
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('@app/pages/login/login.page').then((m) => m.LoginPage),
    canActivate: [noAuthGuard],
    data: { title: 'AUTH.LOGIN' },
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('@app/pages/forgot-password/forgot-password.page').then((m) => m.ForgotPasswordPage),
    canActivate: [noAuthGuard],
    data: { title: 'FORGOT_PASSWORD.TITLE' },
  },
  {
    path: 'auth/reset-password',
    loadComponent: () =>
      import('@app/pages/reset-password/reset-password.page').then((m) => m.ResetPasswordPage),
    canActivate: [noAuthGuard],
    data: { title: 'AUTH.RESET_PASSWORD' },
  },
  {
    path: 'setup-account',
    loadComponent: () =>
      import('@app/pages/setup-account/setup-account.page').then((m) => m.SetupAccountPage),
    canActivate: [noAuthGuard],
    data: { title: 'SETUP_ACCOUNT.TITLE' },
  },
  {
    path: 'error',
    loadComponent: () =>
      import('@app/pages/error/error.page').then((m) => m.ErrorPage),
    data: { title: 'ERROR.TITLE' },
  },
  {
    path: 'home',
    loadComponent: () =>
      import('@app/pages/home/home.page').then((m) => m.HomePage),
    canActivate: [authGuard],
    data: { title: 'MENU.DASHBOARD' },
  },
  {
    path: 'home2',
    loadComponent: () =>
      import('@app/pages/home2/home2.page').then((m) => m.Home2Page),
    canActivate: [authGuard],
    data: { title: 'HOME2.DASHBOARD' },
  },
  {
    path: 'data-import',
    loadComponent: () => import('@app/pages/data-import/data-import.page').then( m => m.DataImportPage),
    canActivate: [authGuard],
    data: { title: 'DATA_IMPORT.TITLE' },
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('@app/pages/profile/profile.page').then((m) => m.ProfilePage),
    canActivate: [authGuard],
    data: { title: 'PROFILE.MY_PROFILE' },
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('@app/pages/settings/settings.page').then((m) => m.SettingsPage),
    canActivate: [authGuard],
    data: { title: 'SETTINGS.FORM_CUSTOMIZATION.TITLE' },
  },
  {
    path: 'document-tree-picker',
    loadComponent: () =>
      import('@app/pages/document-tree-picker/document-tree-picker.page').then((m) => m.DocumentTreePickerPage),
    canActivate: [authGuard, roleGuard(['SUPER_ADMIN', 'CLIENT_ADMIN', 'SUBSIDIARY_ADMIN'])],
    canDeactivate: [canDeactivateGuard],
    data: { title: 'DOCUMENT_TREE_PICKER.TITLE' },
  },
  {
    path: 'claim-settings',
    loadComponent: () =>
      import('@app/pages/claim-settings/claim-settings.page').then((m) => m.ClaimSettingsPage),
    canActivate: [authGuard, roleGuard(['SUPER_ADMIN', 'CLIENT_ADMIN', 'SUBSIDIARY_ADMIN'])],
    canDeactivate: [canDeactivateGuard],
    data: { title: 'Claim settings' },
  },
  {
    path: 'xls-reporting',
    loadComponent: () =>
      import('@app/pages/xls-reporting/xls-reporting.page').then((m) => m.XlsReportingPage),
    canActivate: [authGuard],
    data: { title: 'XLS_REPORTING.TITLE' },
  },
  {
    path: 'calculated-columns',
    loadComponent: () =>
      import('@app/pages/calculated-columns/calculated-columns.page').then((m) => m.CalculatedColumnsPage),
    canActivate: [authGuard, roleGuard(['SUPER_ADMIN'])],
    data: { title: 'CALCULATED_COLUMNS.TITLE' },
  },
  {
    path: 'inboxManagement',
    loadComponent: () =>
      import('@app/pages/inbox-management/inbox-management.page').then((m) => m.InboxManagementPage),
    canActivate: [authGuard],
    data: { title: 'INBOX_MANAGEMENT.TITLE' },
  },
  // {
  //   path: 'clients',
  //   loadComponent: () =>
  //     import('@app/pages/clients/client-master/clients.page').then((m) => m.ClientsPage),
  //   canActivate: [authGuard],
  // },
  {
    path: 'clients/CLIENTS_DETAIL/new',
    loadComponent: () =>
      import('@app/pages/clients/client-detail/client-detail.page').then((m) => m.ClientDetailPage),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateGuard],
    data: { title: 'CLIENTS_DETAIL.NEW' },
  },
  {
    path: 'clients/:id',
    loadComponent: () =>
      import('@app/pages/clients/client-detail/client-detail.page').then((m) => m.ClientDetailPage),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateGuard],
    data: { title: 'CLIENTS_DETAIL.CLIENTS_DETAILS' },
  },
  // {
  //   path: 'policies',
  //   loadComponent: () =>
  //     import('@app/pages/policies/policy-master/policies.page').then((m) => m.PoliciesPage),
  //   canActivate: [authGuard],
  // },
  // {
  //   path: 'policies/new',
  //   loadComponent: () =>
  //     import('@app/pages/policies/policy-detail/policy-detail.page').then((m) => m.PolicyDetailPage),
  //   canActivate: [authGuard],
  //   canDeactivate: [canDeactivateGuard],
  // },
  // {
  //   path: 'policies/:id',
  //   loadComponent: () =>
  //     import('@app/pages/policies/policy-detail/policy-detail.page').then((m) => m.PolicyDetailPage),
  //   canActivate: [authGuard],
  //   canDeactivate: [canDeactivateGuard],
  // },
  {
    path: ':formName',
    loadComponent: () =>
      import('@app/pages/master-detail/master-page/master.page').then((m) => m.MasterPage),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateGuard],
    data: { title: 'COMMON.LOADING' },
  },
  {
    path: ':formName/:pageName/new',
    loadComponent: () =>
      import('@app/pages/master-detail/detail-page/detail.page').then((m) => m.DetailPage),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateGuard],
    data: { title: 'COMMON.LOADING' },
  },
  {
    path: ':formName/:pageName/:id',
    loadComponent: () =>
      import('@app/pages/master-detail/detail-page/detail.page').then((m) => m.DetailPage),
    canActivate: [authGuard],
    canDeactivate: [canDeactivateGuard],
    data: { title: 'COMMON.LOADING' },
  },
];
